import { render, staticRenderFns } from "./card-email.vue?vue&type=template&id=776af1be&scoped=true"
import script from "./card-email.vue?vue&type=script&lang=js"
export * from "./card-email.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776af1be",
  null
  
)

export default component.exports